var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Settings",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4310",
    "data-name": "Path 4310",
    d: "M0,0H20V20H0Z",
    fill: "none",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4311",
    "data-name": "Path 4311",
    d: "M9.1,4.1a1.436,1.436,0,0,1,2.792,0,1.437,1.437,0,0,0,2.144.888,1.437,1.437,0,0,1,1.975,1.975A1.437,1.437,0,0,0,16.9,9.1a1.436,1.436,0,0,1,0,2.792,1.437,1.437,0,0,0-.888,2.144,1.437,1.437,0,0,1-1.975,1.975A1.437,1.437,0,0,0,11.9,16.9a1.436,1.436,0,0,1-2.792,0,1.437,1.437,0,0,0-2.144-.888,1.437,1.437,0,0,1-1.975-1.975A1.437,1.437,0,0,0,4.1,11.9,1.436,1.436,0,0,1,4.1,9.1,1.437,1.437,0,0,0,4.986,6.96,1.437,1.437,0,0,1,6.961,4.985,1.435,1.435,0,0,0,9.1,4.1Z",
    transform: "translate(-0.5 -0.5)",
    fill: "none",
    stroke: "auto",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4312",
    "data-name": "Path 4312",
    d: "M9,11.5A2.5,2.5,0,1,0,11.5,9,2.5,2.5,0,0,0,9,11.5",
    transform: "translate(-1.5 -1.5)",
    fill: "none",
    stroke: "auto",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.cb9ca5cc83f4907e2b8431240b364d4e.svg";
export { ForwardRef as ReactComponent };